import {createReducer, on} from '@ngrx/store';
import {EditActions} from '../actions/edit.actions';
import {EditState} from '../states/edit-state.interface';
import {BelegEntitiesActions} from '../actions/beleg-entities.actions';

export const initialEditState: EditState = {
  belegIds: [],
  formBlockValidBeleg: false,
  openOverviewPage: false,
};

export const editReducer = createReducer(
  initialEditState,

  on(EditActions.openEdit, (state, action) => ({
    ...state,
    belegId: action.belegId,
    belegIds: action.belegIds,
  })),

  on(EditActions.setCurrentBelegId, (state, action) => ({
    ...state,
    belegId: action.belegId,
  })),

  on(EditActions.changedFormFieldEingangAusgang, (state, action) => {
    return {
      ...state,
      formFieldBelegeingang: action.belegeingang,
    };
  }),

  on(EditActions.changedFormFieldDatum, (state, action) => {
    return {
      ...state,
      formFieldBelegdatum: action.datum,
    };
  }),

  on(EditActions.changedFormFieldVorgangsartId, (state, action) => {
    return {
      ...state,
      formFieldVorgangsartId: action.vorgangsartId,
    };
  }),

  on(EditActions.changedFormFieldPartnerbezeichnung, (state, action) => {
    return {
      ...state,
      formFieldPartnerbezeichnung: action.partnerbezeichnung,
    };
  }),

  on(EditActions.changedFormFieldBetrag, (state, action) => {
    return {
      ...state,
      formFieldBetrag: action.betrag,
    };
  }),

  on(EditActions.changedFormFieldDauerbeleg, (state, action) => {
    return {
      ...state,
      formFieldDauerbeleg: action.dauerbeleg,
    };
  }),

  on(EditActions.changedFormFieldZahlungsart, (state, action) => {
    return {
      ...state,
      formFieldZahlungsart: action.zahlungsart,
    };
  }),

  on(EditActions.changedFormFieldKommentar, (state, action) => {
    return {
      ...state,
      formFieldKommentar: action.kommentar,
    };
  }),

  on(EditActions.firstBeleg, state => {
    if (!state.belegIds.length) return state;
    return {
      ...state,
      belegId: state.belegIds[0],
    };
  }),

  on(EditActions.previousBeleg, state => {
    if (!state.belegId || !state.belegIds.length) return state;
    const currentIndex = state.belegIds.indexOf(state.belegId);
    if (currentIndex <= 0) return state;

    return {
      ...state,
      belegId: state.belegIds[currentIndex - 1],
    };
  }),

  on(EditActions.nextBeleg, state => {
    if (!state.belegId) return state;

    const currentIndex = state.belegIds.indexOf(state.belegId);

    if (currentIndex === -1 || currentIndex >= state.belegIds.length - 1) {
      // INFO: Wenn es der letzte Beleg ist, dann die Übersicht-Seite öffnen
      return {
        ...state,
        openOverviewPage: true,
      };
    } else {
      return {
        ...state,
        belegId: state.belegIds[currentIndex + 1],
      };
    }
  }),

  on(EditActions.openOverviewPageSuccess, state => {
    return {
      ...state,
      openOverviewPage: false,
    };
  }),

  on(EditActions.lastBeleg, state => {
    if (!state.belegIds.length) return state;
    return {
      ...state,
      belegId: state.belegIds[state.belegIds.length - 1],
    };
  }),

  on(EditActions.setCurrentBelegByNumber, (state, action) => {
    if (action.belegNumber < 1 || action.belegNumber > state.belegIds.length) {
      return state;
    }
    return {
      ...state,
      belegId: state.belegIds[action.belegNumber - 1],
    };
  }),

  on(EditActions.updateFormBlockValidityBeleg, (state, {valid}) => {
    return {
      ...state,
      formBlockValidBeleg: valid,
    };
  }),

  on(BelegEntitiesActions.moveSuccess, (state, action) => {
    return handlePrevOrNextBeleg(state, action.belegId);
  }),

  on(BelegEntitiesActions.deleteBelegSuccess, (state, action) => {
    return handlePrevOrNextBeleg(state, action.belegId);
  }),
);

/**
 * Handhabt die Navigation zum vorherigen oder nächsten Beleg nach dem Verschieben oder Löschen eines Belegs.
 *
 * @param state
 * @param belegId
 */
function handlePrevOrNextBeleg(state: EditState, belegId: string): EditState {
  if (!state.belegId) return state;

  // INFO: Verschobenen Beleg aus der Liste entfernen.
  const updatedBelegIds = state.belegIds.filter(id => id !== belegId);

  // INFO: Navigation zum vorherigen oder nächsten Beleg starten
  const oldIndex = state.belegIds.indexOf(belegId);
  if (updatedBelegIds.length <= 1 || oldIndex === -1) {
    // INFO: Es existiert kein Beleg mehr in der Liste, also Übersicht-Seite öffnen.
    return {
      ...state,
      belegIds: updatedBelegIds,
      openOverviewPage: true,
    };
  } else if (oldIndex >= updatedBelegIds.length) {
    // INFO: Wenn es der letzte Beleg ist, dann zum vorherigen Beleg navigieren.
    return {
      ...state,
      belegId: state.belegIds[oldIndex - 1],
      belegIds: updatedBelegIds,
    };
  } else {
    // INFO: Ansonsten zum nächsten Beleg navigieren.
    return {
      ...state,
      belegId: state.belegIds[oldIndex + 1],
      belegIds: updatedBelegIds,
    };
  }
}
